import { render, staticRenderFns } from "./ProductModalsModal.vue?vue&type=template&id=5f24c85e&scoped=true&"
import script from "./ProductModalsModal.vue?vue&type=script&lang=js&"
export * from "./ProductModalsModal.vue?vue&type=script&lang=js&"
import style0 from "./ProductModalsModal.vue?vue&type=style&index=0&id=5f24c85e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f24c85e",
  null
  
)

export default component.exports